module.exports = __webpack_public_path__ + "img/hr-sand-rock-small-15.6bd9f290.png";